@if (user()) {
    @if (user()?.avatarUrl) {
        <ion-img class="avatar-image circle" [src]="user().avatarUrl"></ion-img>
    } @else {
        <p class="avatar-initials circle">{{ user().name | initials }}</p>
    }
    @if (removable()) {
        <div class="delete circle" (click)="remove()">
            <ion-icon name="close"></ion-icon>
        </div>
    }
}
